/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : APMSettingsItemSelect.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Software Features Item Custom Select component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         : Jan 25, 2022
 *
 * @Version      : Version 1.0
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { Select } from "@scuf/common";
import { SelectOptions } from "models/aircraftDetails";
import { IOption } from "@scuf/common/dist/components/Select/ISelectProps";
import { APMSettingField } from "models/apmSettings";

export interface ISelectProps {
  name: string;
  label: string;
  value: string;
  dataset: SelectOptions | null;
  index: number;
  registerName: (item: number, apmFieldData: APMSettingField) => void;
  onChange: (item: string, value: string, index: number) => void;
  apmFieldValue: APMSettingField;
}
export const APMSettingsItemSelect: FC<ISelectProps> = ({
  name,
  label,
  value,
  registerName,
  index,
  apmFieldValue,
  dataset,
  onChange,
}) => {
  let options: IOption[] = [];
  for (const property in dataset) {
    options = [
      ...options,
      { value: dataset[property], text: dataset[property] },
    ];
  }

  return (
    <>
      <Select
        ref={() => registerName(index, apmFieldValue)}
        label={label}
        name={name}
        data-testid={label}
        options={options}
        value={value}
        onChange={(currentValue) => onChange(name, currentValue, index)}
      />
    </>
  );
};
